import React from 'react';

export const escapeHtmlHelper = (text) =>  {

    const urltext = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/i;

    if (text) {
        return text
            .replace(/â€“/g, "—")
            .replace(/â€”/g, "_")
            .replace(/â€"/g, "—")
            .replace(/â€œ/g, "“")
            .replace(/â€/g, "”")
            .replace(/â€¦/g, "...")
            .replace(/â€¢/g, "-")
            .replace(/â€˜/g, "'")
            .replace(/â€™/g, "'")
            .replace(/â‚¬/g, "€")
            .replace(/Â/g, " ")
            .replace(/â€š/g, ",")
            .replace(/â€¦/g, "...")
            .replace(/Â¢/g, "¢")
            .replace(/â„¢/g, "™")
            .replace(/Â£/g, "£")
            .replace(/Â/g, " ")
            .replace(/Ëœ/g, "˜")
            .replace(urltext, "<a href='$1'>$1</a>");
    }
};

export const removeHtmlTags = (str) => {
    return str.replace(/<(?:.|\n)*?>/gm, '');
};


// WEBPACK FOOTER //
// src/client/components/site/features/profile/helpers/markupHelpers.js